export enum SlotType {
  WIDGET = 'WIDGET',
  LOGICAL = 'LOGICAL',
}
